export const userHasCalendarWriteAccess = (user) => user.userTypeId === UserType.DashboardUser ||
    user.userTypeId === UserType.FacilityAdmin ||
    user.userTypeId === UserType.SystemAdmin;
var UserType;
(function (UserType) {
    UserType[UserType["DashboardUser"] = 1] = "DashboardUser";
    UserType[UserType["FacilityAdmin"] = 2] = "FacilityAdmin";
    UserType[UserType["Contractor"] = 3] = "Contractor";
    UserType[UserType["Manufacturer"] = 4] = "Manufacturer";
    UserType[UserType["MaintenanceContractor"] = 5] = "MaintenanceContractor";
    UserType[UserType["ConsultantArchitect"] = 6] = "ConsultantArchitect";
    UserType[UserType["FootballFoundation"] = 7] = "FootballFoundation";
    UserType[UserType["SystemAdmin"] = 8] = "SystemAdmin";
    UserType[UserType["OtherUser"] = 9] = "OtherUser";
})(UserType || (UserType = {}));
//# sourceMappingURL=userHasCalendarWriteAccess.js.map